export const getProbationReduction = (probationAbsolute: StringOrNumber, baseAmount: StringOrNumber) => {
  const result = +((1 - +probationAbsolute / +baseAmount) * 100).toFixed(2);

  if (result < 0 || result > 100 || +probationAbsolute < 0 || +baseAmount < 0) {
    return '';
  }

  return result || result === 0 ? result : '';
};
